<script>
import { defineComponent } from 'vue'
import { Carousel, Slide } from 'vue3-carousel'
export default defineComponent({
  name: 'Gallery',
  components: {
    Carousel,
    Slide,
  },
  data: () => ({
    currentSlide: 0,
    breakpoints: {
      // 700px and up
      700: {
        itemsToShow: 1.5,
        snapAlign: 'center',
      },
      // 1024 and up
      1024: {
        itemsToShow: 1.5,
        snapAlign: 'center',
      },
      1280: {
        itemsToShow: 1.5,
        snapAlign: 'center',
      },
      1536: {
        itemsToShow: 1.5,
        snapAlign: 'center',
      },
      1800: {
        itemsToShow: 2,
        snapAlign: 'center',
      },
      2100: {
        itemsToShow: 2.5,
        snapAlign: 'center',
      },
      2400: {
        itemsToShow: 3,
        snapAlign: 'center',
      },
      2700: {
        itemsToShow: 3.5,
        snapAlign: 'center',
      },
      3000: {
        itemsToShow: 4,
        snapAlign: 'center',
      },
    },
  }),
  methods: {
    slideTo(val) {
      this.currentSlide = val
    },
  },
})
</script>

<script setup>
import { onMounted, onUnmounted } from 'vue'
const props = defineProps({
  carousel: Array,
})

onMounted(() => {})
onUnmounted(() => {})
</script>
<template>
  <div class="brand-carousel">
    <carousel id="brand-carousel" v-model="currentSlide" :autoplay="10000" :wrap-around="true" :items-to-show="1" :transition="500" :breakpoints="breakpoints" class="brand-carousel-slide">
      <slide v-for="info in carousel" :key="info">
        <div class="item">
          <div class="img"><img :src="info.carouselImg" alt="" /></div>
          <div class="info">
            <div>
              <h3 class="title font-rift">
                <span class="title1 brandcolor text-2xl">
                  {{ info.carouselTitle }}
                </span>
                <span class="title2 text-lg">
                  {{ info.carouselTitle2 }}
                </span>
              </h3>
              <p class="text mt-2 text-sm leading-7">
                {{ info.carouselTxt }}
              </p>
            </div>
          </div>
        </div>
      </slide>
    </carousel>
  </div>
</template>
